import { configurationApi } from '../configurationApi';
import { PayerType } from '../types/payerType';

interface UploadResponse {
  successful: number;
  failed: number;
  errors: string[];
  isSuccess: boolean;
  errorMessage: string;
}

const payerEndpoints = configurationApi.injectEndpoints({
  endpoints: (builder) => ({
    getPayers: builder.query<PayerType[], { company: string; centerId: string }>({
      query: ({ company, centerId }) =>
        `/payers?company=${encodeURIComponent(company)}&centerId=${encodeURIComponent(centerId)}`,
      providesTags: ['Payers'],
    }),

    getEvaEnabledPayers: builder.query<PayerType[], { company: string }>({
      query: ({ company }) => `/payers/eva-enabled/details?company=${encodeURIComponent(company)}`,
      providesTags: ['Payers'],
    }),

    getPayer: builder.query<PayerType, { company: string; centerId: string; payerId: string }>({
      query: ({ company, centerId, payerId }) =>
        `/payer?company=${encodeURIComponent(company)}&centerId=${encodeURIComponent(
          centerId,
        )}&payerId=${encodeURIComponent(payerId)}`,
      providesTags: ['Payers'],
    }),

    upsertPayer: builder.mutation<PayerType, PayerType>({
      query: (payer) => ({
        url: '/payer',
        method: 'POST',
        body: payer,
      }),
      invalidatesTags: ['Payers'],
    }),

    uploadPayers: builder.mutation<
      UploadResponse,
      { company: string; centerId: string; file: File }
    >({
      query: ({ company, centerId, file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `Company/${company}/Center/${centerId}/Payers/Upload`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Payers'],
    }),

    downloadPayers: builder.mutation<Blob, { company: string; centerId: string }>({
      query: ({ company, centerId }) => ({
        url: `Company/${company}/Center/${centerId}/Payers/Download`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),

    getPayerGroups: builder.query<{ name: string; value: string; tradingPartnerId: string }[], void>({
      query: () => '/PayerGroups',
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPayersQuery,
  useGetEvaEnabledPayersQuery,
  useGetPayerQuery,
  useUpsertPayerMutation,
  useUploadPayersMutation,
  useDownloadPayersMutation,
  useGetPayerGroupsQuery,
} = payerEndpoints;
